import request from "./request";

const AssessmentService = {
    GetAll: async (context, signal) => {
        return await request.sendRequest(`/assessment/all`, context.token, signal);
    },
    GetList: async (context, signal) => {
        return await request.sendRequest(`/assessment/list`, context.token, signal);
    },
    GetMCQList: async (context,signal) => {
        return await request.sendRequest(`/assessment/mcq/list`, context.token, signal);
    },
    GetTypes: async (id, context, signal) => {
        return await request.sendRequest(`/assessment/types/${id}`, context.token, signal);
    },
    GetPracticalList: async (context, signal) => {
        return await request.sendRequest(`/assessment/practical/list`, context.token, signal);
    },
    GetInfo: async (id, context, signal) => {
        return await request.sendRequest(`/assessment/info/${id}`, context.token, signal);
    },
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/assessment/${id}`, context.token, signal);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/assessment`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/assessment/${id}`, context.token);
    },
};

export default AssessmentService;
